import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatisticsPdfTitle = _resolveComponent("StatisticsPdfTitle")!
  const _component_SwitchTab = _resolveComponent("SwitchTab")!

  return (_openBlock(), _createBlock(_component_SwitchTab, {
    mode: "line",
    textTrue: _ctx.textTrue,
    textFalse: _ctx.textFalse,
    defaultSelectSecondTab: _ctx.defaultSelectSecondTab
  }, {
    "first-tab": _withCtx(() => [
      _createVNode(_component_StatisticsPdfTitle, { title: _ctx.pdfFirstTitle }, null, 8, ["title"]),
      _renderSlot(_ctx.$slots, "first-tab")
    ]),
    "second-tab": _withCtx(() => [
      _createVNode(_component_StatisticsPdfTitle, { title: _ctx.pdfSecondTitle }, null, 8, ["title"]),
      _renderSlot(_ctx.$slots, "second-tab")
    ]),
    _: 3
  }, 8, ["textTrue", "textFalse", "defaultSelectSecondTab"]))
}